export default "__VITE_ASSET__21cf729c__"